/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2, typography2 } from '@coursera/cds-core';

import DegreesModalCta from 'bundles/unified-description-page-common/components/modules/credits/DegreesModalCta';
import type { DegreeFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import { formatPageDataDegrees } from 'bundles/unified-description-page-common/utils/formatPageDataDegrees';
import { useMWebStreamlinedXDP } from 'bundles/unified-description-page-common/utils/useStreamlinedXDP';

import _t from 'i18n!nls/xdp';

type Props = {
  description?: string;
  degrees?: Array<DegreeFragment> | null;
  disclaimer?: string;
  modalTitle?: string;
  disableCta?: boolean;
};

const styles = {
  mWebXDPContainer: css`
    button span {
      ${typography2.bodyPrimary}
    }
  `,
};

const EligibleDegreesInfo = ({ description, degrees, disclaimer, modalTitle, disableCta }: Props) => {
  const isMWebStreamlinedXDP = useMWebStreamlinedXDP();
  if (!description || !degrees || !degrees.length) {
    return null;
  }

  return (
    <Typography2 component="span" variant="bodyPrimary" css={isMWebStreamlinedXDP ? styles.mWebXDPContainer : ''}>
      {isMWebStreamlinedXDP ? (
        <FormattedMessage
          message={_t(`Degree credit eligible, {modalCta}`)}
          modalCta={
            <DegreesModalCta
              modalDescription={<Typography2 component="p">{description}</Typography2>}
              descriptionDisclaimer={disclaimer}
              degrees={formatPageDataDegrees(degrees)}
              modalTitle={modalTitle}
              disableCta={disableCta}
            />
          }
        />
      ) : (
        <>
          {description}
          <DegreesModalCta
            modalDescription={<Typography2 component="p">{description}</Typography2>}
            descriptionDisclaimer={disclaimer}
            degrees={formatPageDataDegrees(degrees)}
            modalTitle={modalTitle}
            disableCta={disableCta}
          />
        </>
      )}
    </Typography2>
  );
};

export default EligibleDegreesInfo;
